"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delegationBackendSchema = exports.delegationUpdateBackendSchema = void 0;
var delegation_frontend_schema_1 = require("./delegation-frontend-schema");
exports.delegationUpdateBackendSchema = __assign(__assign({}, delegation_frontend_schema_1.delegationFrontendSchema), { properties: __assign(__assign({}, delegation_frontend_schema_1.delegationFrontendSchema.properties), { delegationID: {
            // optional
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should be a UUIDv4',
        } }), additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    }, required: __spreadArrays(delegation_frontend_schema_1.delegationFrontendSchema.required, [
        'activationTimestamp',
        'expiryTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ]) });
exports.delegationBackendSchema = __assign(__assign({}, exports.delegationUpdateBackendSchema), { required: __spreadArrays(exports.delegationUpdateBackendSchema.required, [
        'recordCreatedTimestamp',
        'recordCreatedUserID',
    ]) });
